var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeLampada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 104,
    viewBox: "0 0 82 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_246_604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2047 50.9738C58.2859 47.9965 59.5 44.3688 59.5 40.4375C59.5 30.2191 51.2184 21.9375 41 21.9375C30.7816 21.9375 22.5 30.2191 22.5 40.4375C22.5 44.3688 23.7141 47.9965 25.7953 50.9738C26.3301 51.7398 26.966 52.607 27.6453 53.532C29.5098 56.0902 31.7355 59.1543 33.3977 62.175C34.9008 64.9211 35.6668 67.7828 36.0426 70.4855H29.0039C28.6859 68.7512 28.1512 67.0602 27.2984 65.4992C25.8676 62.8977 24.0898 60.4551 22.3121 58.0125C21.5605 56.9863 20.809 55.9602 20.0863 54.9195C17.2391 50.8293 15.5625 45.8285 15.5625 40.4375C15.5625 26.3891 26.9516 15 41 15C55.0484 15 66.4375 26.3891 66.4375 40.4375C66.4375 45.8285 64.7609 50.8293 61.8992 54.934C61.1766 55.9746 60.425 57.0008 59.6734 58.027C57.8957 60.4551 56.118 62.8977 54.6871 65.5137C53.8344 67.0746 53.2996 68.7656 52.9816 70.5H45.9719C46.3477 67.7973 47.1137 64.9211 48.6168 62.1895C50.2789 59.1688 52.5047 56.1047 54.3691 53.5465C55.0484 52.6215 55.6699 51.7543 56.2047 50.9883V50.9738ZM41 33.5C37.1699 33.5 34.0625 36.6074 34.0625 40.4375C34.0625 41.7094 33.0219 42.75 31.75 42.75C30.4781 42.75 29.4375 41.7094 29.4375 40.4375C29.4375 34.0492 34.6117 28.875 41 28.875C42.2719 28.875 43.3125 29.9156 43.3125 31.1875C43.3125 32.4594 42.2719 33.5 41 33.5ZM41 89C34.6117 89 29.4375 83.8258 29.4375 77.4375V75.125H52.5625V77.4375C52.5625 83.8258 47.3883 89 41 89Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_246_604",
    x: 0.5625,
    y: 0,
    width: 80.875,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988235 0 0 0 0 0.223529 0 0 0 0 0.988235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_246_604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_246_604",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeLampada);
export default __webpack_public_path__ + "static/media/icone-lampada.320dbf721cecd080a6f3a9424e721a9c.svg";
export { ForwardRef as ReactComponent };